/* global process */
import axios from "axios";
import http from "@/utils/request";

// 凭证仍通过业务请求封装获取，保留登录校验、traceId 和 401 处理。
export function getQnyToken() {
  return http.request({
    url: "/api/paipika-service/upload/token",
    method: "GET",
  });
}

// 接收原 /upload/image 的 file、name、dir 表单，保持对象键及成功响应不变。
export async function uploadImageToQiniu(data, onUploadProgress) {
  const file = data.get("file");
  const name = data.get("name");
  const directory = data.get("dir") || "upload";
  if (!(file instanceof Blob) || file.size === 0) {
    throw new Error("文件不能为空");
  }
  if (typeof name !== "string" || !name || typeof directory !== "string") {
    throw new Error("上传文件名或目录无效");
  }

  // 与后端 dir + "/" + name 一致，不补域名、不改后缀、不重新生成文件名。
  const key = `${directory}/${name}`;
  const uploadUrl = process.env.VUE_APP_QINIU_UPLOAD_URL;
  if (!uploadUrl || !uploadUrl.startsWith("https://")) {
    throw new Error("未配置有效的七牛上传加速地址");
  }

  const tokenResponse = await getQnyToken();
  if (tokenResponse?.code !== 0) {
    throw new Error(tokenResponse?.message || "获取上传凭证失败");
  }
  const token = tokenResponse.data?.token;
  if (typeof token !== "string" || !token.trim()) {
    throw new Error("未获取到有效的七牛上传凭证");
  }

  const formData = new FormData();
  formData.append("token", token);
  formData.append("key", key);
  formData.append("file", file, name);

  let response;
  try {
    // 七牛只接收上传凭证，不附加后台 Token、traceId 或 Cookie。
    // Content-Type 及 multipart boundary 由浏览器生成。
    response = await axios.post(uploadUrl, formData, {
      timeout: 120000,
      withCredentials: false,
      onUploadProgress,
    });
  } catch (error) {
    // 不向调用方传递含上传 token 的 Axios config，避免页面日志输出凭证。
    if (error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT") {
      throw new Error("图片上传超时，请检查网络后重试");
    }
    const status = error?.response?.status;
    const detail = error?.response?.data?.error;
    throw new Error(
      status
        ? `七牛上传失败（${status}）${typeof detail === "string" ? `：${detail}` : ""}`
        : "图片上传失败，请检查网络及七牛跨域配置后重试",
    );
  }

  if (response.status !== 200 || response.data?.key !== key) {
    throw new Error("七牛返回的上传路径与预期不一致，请重试");
  }

  // 旧接口成功时 data 为 null。保持此约定，让各业务继续使用原有路径规则，
  // 尤其入库/发货只保存文件名，不能把七牛完整 key 再拼到 /upload/ 后面。
  return { code: 0, message: "成功", data: null };
}
